import { createAction, props } from '@ngrx/store';

import { TagCommanderClickType } from '../../shared/tag-commander/tag-commander.types';

export const trackClick = createAction(
  '[Tracking] Track Click',
  props<{ label: string; clickType?: TagCommanderClickType }>(),
);
